/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useMemo } from 'react';

import { jsx } from '@atlaskit/css';
import { FlagsProvider } from '@atlaskit/flag';
import { RovoInlineChatPrompt } from '@atlassian/conversation-assistant-chat-prompt-input';

import type { EditorPluginAIProvider } from '../../../../types/types';
import { useAIExperienceCommonDataContext } from '../../../hooks/useAIExperienceCommonData';

const providerProductToProuductKey = (product: EditorPluginAIProvider['product']) => {
	switch (product) {
		case 'CONFLUENCE':
			return 'confluence';
		case 'JSW':
		case 'JSM':
		case 'JWM':
		case 'JPD':
			return 'jira';
		case 'ATLAS':
		case 'TOWNSQUARE':
			return 'atlas';
		case 'BITBUCKET':
			return 'bitbucket';
		default:
			return 'unknown';
	}
};

interface RovoPromptScreenWithLogicProps {
	cancel: () => void;
}

export function RovoPromptScreenWithLogic({ cancel }: RovoPromptScreenWithLogicProps) {
	const ai = useAIExperienceCommonDataContext();

	const siteId = useMemo(
		() => ai.editorPluginAIProvider?.getChannelVariables?.('rovo-agent')?.cloudId || '',
		[ai.editorPluginAIProvider],
	);
	const product = ai.editorPluginAIProvider.product;
	const productKey = providerProductToProuductKey(product);
	return (
		<FlagsProvider>
			<RovoInlineChatPrompt
				source={productKey === 'confluence' ? 'CONFLUENCE_INLINE_EDITOR' : ''}
				productKey={productKey}
				siteId={siteId}
				// Follow-up: Retrieve the orgId - might need to be a prop or from context
				orgId={''}
				onAbort={cancel}
				onComplete={cancel}
				onSubmit={() => {
					ai.editorPluginAIProvider.onSubmit?.();
				}}
			/>
		</FlagsProvider>
	);
}
